<template>
  <div class="modal-overlay" @click="$emit('close-modal')">
    <div ref="modal" class="modal overflow-hidden z-50 rounded-3xl" :class="customModalClasses" tabindex="0" @click.stop>
      <div class="close" @click="$emit('close-modal')">
        <slot name="icon"/>
      </div>
      <slot />
    </div>
  </div>
</template>

<script setup lang="ts">
interface Props {
  customModalClasses?: string;
}

const props = withDefaults(defineProps<Props>(), {
  customModalClasses: '',
});

defineEmits(['close-modal']);
const modal = ref<HTMLInputElement | null>(null)
onMounted(() => {
  modal.value?.focus()
})
</script>